import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './parts.css'

/**
 * The footer region of a composed [Modal](/components/modal/). A fixed zone at
 * the bottom for call-to-action buttons; stacks on narrow viewports and lays
 * out as an end-aligned row on wider ones.
 *
 * Auto-assigns itself to the modal's `footer` slot, so place it as a direct
 * child of `nord-modal` (no `slot` attribute needed).
 *
 * @status draft
 * @category overlay
 * @lightDom true
 *
 * @slot - The modal footer content.
 */
@customElement('nord-modal-footer')
export default class ModalFooter extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    if (!this.hasAttribute('slot')) {
      this.setAttribute('slot', 'footer')
    }
    injectLegacyLightDomStyles(this, style, 'nord-modal-parts')
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-modal-footer': ModalFooter
  }
}
